export enum CrmExceptionCodeEnum {
  GDPR_REQUEST_ALREADY_SUBMITTED = 5003
}
